import {createSelector} from 'reselect';
import {getOrderSummary} from '../selectors';

const getPaymentOptionsFromOrderSummary = createSelector(
  [getOrderSummary],
  orderSummary => orderSummary?.paymentOptions?.paymentOptions,
);

export default getPaymentOptionsFromOrderSummary;
